import { render, staticRenderFns } from "./SetupTukarPoinAdmin.vue?vue&type=template&id=0f2b9dc5"
import script from "./SetupTukarPoinAdmin.vue?vue&type=script&lang=js"
export * from "./SetupTukarPoinAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports